import React, { useEffect, useState, useMemo } from "react";
import { functionService } from "../../lib/functions";
import * as Styled from "./styled";
import DownloadAssets from "../downloadAssets/download";
import Sidemenu from "../../components/sidemenu";
import { Select, DatePicker, Tooltip, message } from "antd";
import editIcon from "../../images/d_edit.svg";
import eyeWhite from "../../images/eyeWhite.svg";
import copylink from "../../images/copylink.svg";
import invite_blue from "../../images/invite_blue.svg";
import fileIconBlue from "../../images/file_icon_blue.svg";

import { useNavigate } from "react-router-dom";
import dayjs from "dayjs";
import { jsPDF } from "jspdf";

/* ─── Active Toggle Switch ──────────────────────────────────────────────────── */
const switchStyles = {
  wrapper: {
    display: "inline-flex",
    alignItems: "center",
    gap: "7px",
  },
  track: (active, loading) => ({
    position: "relative",
    width: "42px",
    height: "24px",
    borderRadius: "999px",
    background: loading ? "#c8c8c8" : active ? "#4CAF50" : "#E0E0E0",
    cursor: loading ? "not-allowed" : "pointer",
    transition: "background 0.25s ease",
    flexShrink: 0,
    boxShadow: active && !loading ? "0 0 0 3px rgba(76,175,80,0.18)" : "none",
  }),
  thumb: (active) => ({
    position: "absolute",
    top: "3px",
    left: active ? "21px" : "3px",
    width: "18px",
    height: "18px",
    borderRadius: "50%",
    background: "#fff",
    boxShadow: "0 1px 4px rgba(0,0,0,0.22)",
    transition: "left 0.22s cubic-bezier(.4,0,.2,1)",
  }),
  label: (active) => ({
    fontSize: "12px",
    fontWeight: 600,
    color: active ? "#4CAF50" : "#9E9E9E",
    userSelect: "none",
    minWidth: "32px",
  }),
};

const ActiveSwitch = ({ active, onToggle, loading }) => (
  <div style={switchStyles.wrapper}>
    <div
      style={switchStyles.track(active, loading)}
      onClick={!loading ? onToggle : undefined}
      role="switch"
      aria-checked={active}
    >
      <div style={switchStyles.thumb(active)} />
    </div>
    <span style={switchStyles.label(active)}>{active ? "Active" : "Inactive"}</span>
  </div>
);
/* ─────────────────────────────────────────────────────────────────────────── */

/* ─── Pagination styles ─────────────────────────────────────────────────────── */
const paginationStyles = {
  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "16px 4px",
    borderTop: "1px solid #F0F0F0",
    marginTop: "8px",
  },
  leftSection: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "13px",
    color: "#6B7280",
  },
  pageControls: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
  },
  pageBtn: (active, disabled) => ({
    minWidth: "34px",
    height: "34px",
    padding: "0 10px",
    borderRadius: "8px",
    border: active ? "none" : "1px solid #E5E7EB",
    background: active ? "#4F46E5" : disabled ? "#F9FAFB" : "#FFFFFF",
    color: active ? "#FFFFFF" : disabled ? "#D1D5DB" : "#374151",
    fontWeight: active ? 600 : 400,
    fontSize: "13px",
    cursor: disabled ? "not-allowed" : "pointer",
    transition: "all 0.15s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    boxShadow: active ? "0 1px 4px rgba(79,70,229,0.3)" : "none",
  }),
  ellipsis: {
    width: "34px",
    height: "34px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#9CA3AF",
    fontSize: "14px",
    userSelect: "none",
  },
  navBtn: (disabled) => ({
    height: "34px",
    padding: "0 14px",
    borderRadius: "8px",
    border: "1px solid #E5E7EB",
    background: disabled ? "#F9FAFB" : "#FFFFFF",
    color: disabled ? "#D1D5DB" : "#374151",
    fontWeight: 500,
    fontSize: "13px",
    cursor: disabled ? "not-allowed" : "pointer",
    display: "flex",
    alignItems: "center",
    gap: "4px",
    transition: "all 0.15s ease",
  }),
};
/* ─────────────────────────────────────────────────────────────────────────── */

/* ─── Section heading style ─────────────────────────────────────────────────── */
const sectionHeadingStyle = {
  fontSize: "16px",
  fontWeight: 700,
  color: "#1F2937",
  margin: "28px 0 12px 0",
  paddingBottom: "8px",
  borderBottom: "2px solid #4F46E5",
  display: "inline-block",
};
/* ─────────────────────────────────────────────────────────────────────────── */

/* ─── Eye button ────────────────────────────────────────────────────────────── */
const EyeButton = ({ onClick }) => (
  <Tooltip title="View JD">
    <button onClick={onClick}>
      <img src={eyeWhite} alt="view" />
    </button>
  </Tooltip>
);

const MiscFileButton = ({ onClick }) => (
  <Tooltip title="View Miscellaneous File">
    <button onClick={onClick}>
      <img
        src={fileIconBlue}
        alt="misc file"
        style={{
          width: "32px",
          height: "32px",
          background: "#DEE2EF",
          objectFit: "contain",
        }}
      />
    </button>
  </Tooltip>
);
/* ─────────────────────────────────────────────────────────────────────────── */

/* ─── Invite button ─────────────────────────────────────────────────────────── */
const InviteButton = ({ onClick, disabled }) => (
  <Tooltip title={disabled ? "Download Intelligence Report first" : "Add Candidate"}>
    <button
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      style={{
        width: "32px",
        height: "32px",
        borderRadius: "8px",
        border: "none",
        background: "#DEE2EF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: disabled ? "not-allowed" : "pointer",
        opacity: disabled ? 0.5 : 1,
      }}
    >
      <img
        src={invite_blue}
        alt="invite"
        style={{
          width: "22px",
          height: "22px",
          objectFit: "contain",
        }}
      />
    </button>
  </Tooltip>
);

// Single declaration of formatReportValue — used by the PDF generator only
// (the popup that previously used this has been removed).
const formatReportValue = (value) => {
  if (value === null || value === undefined) {
    return "-";
  }

  if (typeof value === "string") {
    return value;
  }

  return JSON.stringify(value, null, 2);
};

const getSourcingReportErrorMessage = (
  error,
  fallback = "Failed to generate report. Please try again."
) => {
  const data = error?.response?.data;

  if (typeof data?.error === "string" && data.error.trim()) {
    return data.error;
  }

  if (typeof data?.meta?.message === "string" && data.meta.message.trim()) {
    return data.meta.message;
  }

  if (typeof data?.message === "string" && data.message.trim()) {
    return data.message;
  }

  if (typeof error?.message === "string" && error.message.trim()) {
    return error.message;
  }

  return fallback;
};
/* ─────────────────────────────────────────────────────────────────────────── */

/* ─── Sourcing Report field list ─────────────────────────────────────────────
   Used only by the PDF generator (downloadSourcingReportPDF) to build section
   labels/order. The popup that used to render these fields has been removed.
─────────────────────────────────────────────────────────────────────────── */
const SOURCING_REPORT_FIELDS = [
  { label: "JD Summary", key: "jd_summary" },
  { label: "Ideal Candidate", key: "ideal_candidate" },
  { label: "Screening Questions", key: "screening_questions" },
  { label: "Skills Understanding", key: "skills_understanding" },
  { label: "Boolean Search Strings", key: "boolean_search_strings" },
  { label: "Recruiter Shortlisting Guide", key: "recruiter_shortlisting_guide" },
  { label: "Target Companies, Roles & Keywords", key: "sourcing_targets" },
];
/* ─────────────────────────────────────────────────────────────────────────── */

/* ─── Generate Sourcing Report button (no popup) ────────────────────────────
   Shown only when no report exists yet AND adminAccess !== "3".
   Clicking it calls onGenerate(item) directly — no popup, no JSON display.
   Once generation succeeds, the parent replaces this with DownloadReportButton.
─────────────────────────────────────────────────────────────────────────── */
const GenerateSourcingReportButton = ({ item, isGenerating, onGenerate }) => {
  const handleClick = () => {
    if (isGenerating) return;
    onGenerate(item);
  };

  return (
    <Tooltip title={isGenerating ? "Generating Sourcing Report" : "Generate Sourcing Report"}>
      <Styled.AiScoreButton
        loading={isGenerating}
        disabled={isGenerating}
        onClick={handleClick}
      />
    </Tooltip>
  );
};
/* ─────────────────────────────────────────────────────────────────────────── */

/* ─── Download Report button ─────────────────────────────────────────────────
   Renders the already-generated sourcing report as a PDF entirely on the
   frontend. Never calls the LLM and never calls the sourcing-report
   generation endpoint. Shown to EVERY user (including adminAccess === 3)
   once a report exists — either from the backend (item.intelligence_report)
   or from the local generation cache.
─────────────────────────────────────────────────────────────────────────── */
const DownloadReportButton = ({ onClick }) => (
  <Tooltip title="Download Intelligence Report">
    <button
      onClick={onClick}
      style={{
        width: "32px",
        height: "32px",
        borderRadius: "8px",
        border: "none",
        background: "#DEE2EF",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "pointer",
      }}
    >
      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 3v12m0 0l-4-4m4 4l4-4M4 21h16"
          stroke="#1B49EA"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </button>
  </Tooltip>
);


const downloadSourcingReportPDF = async (item, reportData, onReportDownloaded) => {
  if (!reportData) return;

  const isRawText = typeof reportData === "string";

  const normalizedReport = isRawText
    ? reportData
    : {
      ...reportData,
      jd_summary: reportData.jd_summary || reportData.jd_breakdown,
    };

  const hasReportContent = isRawText
    ? reportData.trim().length > 0
    : SOURCING_REPORT_FIELDS.some(({ key }) => {
      const val = normalizedReport[key];

      if (val === null || val === undefined || val === "") return false;
      if (Array.isArray(val)) return val.length > 0;
      if (typeof val === "object") return Object.keys(val).length > 0;
      return true;
    });

  if (!hasReportContent) {
    message.error("Sourcing report has no data to download yet.");
    return;
  }

  const doc = new jsPDF({ unit: "pt", format: "a4" });

  const pageWidth = doc.internal.pageSize.getWidth();
  const pageHeight = doc.internal.pageSize.getHeight();

  const margin = 40;
  const maxWidth = pageWidth - margin * 2;

  let y = 50;

  const ensureSpace = (requiredHeight = 20) => {
    if (y + requiredHeight > pageHeight - margin) {
      doc.addPage();
      y = 50;
    }
  };

  const sanitizeInlineText = (text) => {
    return String(text)
      .replace(/\*\*(.*?)\*\*/g, "$1")
      .replace(/(?<!\*)\*(?!\*)(.*?)(?<!\*)\*(?!\*)/g, "$1")
      .replace(/[\u2018\u2019]/g, "'")
      .replace(/[\u201C\u201D]/g, '"')
      .replace(/[\u2013\u2014]/g, "-")
      .replace(/\u2192/g, "->")
      .replace(/\u2248/g, "~")
      .replace(/\u2026/g, "...")
      .replace(/\u2022/g, "-")
      .trim();
  };

  const addText = (
    text,
    {
      fontSize = 10,
      bold = false,
      indent = 0,
      spacing = 14,
    } = {}
  ) => {
    if (text === null || text === undefined || text === "") {
      return;
    }

    const safeText = sanitizeInlineText(text);
    if (!safeText) return;

    doc.setFontSize(fontSize);
    doc.setFont(undefined, bold ? "bold" : "normal");

    const lines = doc.splitTextToSize(
      safeText,
      maxWidth - indent
    );

    lines.forEach((line) => {
      ensureSpace(spacing);
      doc.text(line, margin + indent, y);
      y += spacing;
    });
  };

  const addBullet = (text, indent = 12) => {
    if (!text) return;

    const safeText = sanitizeInlineText(text);
    if (!safeText) return;

    doc.setFontSize(10);
    doc.setFont(undefined, "normal");

    const bullet = "•";
    const textWidth = maxWidth - indent - 12;

    const lines = doc.splitTextToSize(
      safeText,
      textWidth
    );

    lines.forEach((line, index) => {
      ensureSpace(14);

      if (index === 0) {
        doc.text(bullet, margin, y);
      }

      doc.text(line, margin + indent, y);
      y += 14;
    });
  };

  const addNumberedItem = (number, text) => {
    if (!text) return;

    const safeText = sanitizeInlineText(text);
    if (!safeText) return;

    doc.setFontSize(10);
    doc.setFont(undefined, "normal");

    const prefix = `${number}.`;

    const lines = doc.splitTextToSize(
      safeText,
      maxWidth - 25
    );

    lines.forEach((line, index) => {
      ensureSpace(14);

      if (index === 0) {
        doc.text(prefix, margin, y);
      }

      doc.text(line, margin + 20, y);
      y += 14;
    });
  };

  const renderRawTextReport = (text) => {
    const lines = String(text).split("\n");

    lines.forEach((rawLine) => {
      const line = rawLine.replace(/\s+$/, "");

      if (line.trim() === "") {
        y += 6;
        return;
      }

      if (/^[-*_]{3,}\s*$/.test(line.trim())) {
        ensureSpace(14);
        doc.setDrawColor(200, 200, 200);
        doc.setLineWidth(0.5);
        doc.line(margin, y, margin + maxWidth, y);
        y += 10;
        return;
      }

      const headingMatch = line.match(/^(#{1,6})\s+(.*)$/);
      if (headingMatch) {
        const level = headingMatch[1].length;
        const headingText = sanitizeInlineText(headingMatch[2]);

        ensureSpace(24);
        y += level <= 2 ? 6 : 2;

        doc.setFontSize(level === 1 ? 15 : level === 2 ? 13 : 11.5);
        doc.setFont(undefined, "bold");

        const headingLines = doc.splitTextToSize(headingText, maxWidth);
        headingLines.forEach((hLine) => {
          ensureSpace(18);
          doc.text(hLine, margin, y);
          y += 16;
        });

        y += 2;
        return;
      }

      const bulletMatch = line.match(/^\s*[-*•]\s+(.*)$/);
      if (bulletMatch) {
        addBullet(sanitizeInlineText(bulletMatch[1]));
        return;
      }

      const numberedMatch = line.match(/^\s*(\d+)\.\s+(.*)$/);
      if (numberedMatch) {
        addNumberedItem(numberedMatch[1], sanitizeInlineText(numberedMatch[2]));
        return;
      }

      addText(sanitizeInlineText(line));
    });
  };

  const renderLabeledBuckets = (obj) => {
    Object.entries(obj).forEach(([field, fieldValue]) => {
      const label = field
        .replace(/_/g, " ")
        .replace(/\b\w/g, (char) => char.toUpperCase());

      ensureSpace(18);
      doc.setFontSize(10);
      doc.setFont(undefined, "bold");
      doc.text(label, margin, y);
      y += 14;

      if (Array.isArray(fieldValue)) {
        fieldValue.forEach((entry) => {
          addBullet(
            typeof entry === "object" && entry !== null
              ? JSON.stringify(entry)
              : entry
          );
        });
      } else {
        addText(
          typeof fieldValue === "object" && fieldValue !== null
            ? JSON.stringify(fieldValue)
            : fieldValue,
          { indent: 8 }
        );
      }

      y += 5;
    });
  };

  const renderReportValue = (key, value) => {
    if (value === null || value === undefined || value === "") {
      addText("-");
      return;
    }

    if (key === "sourcing_targets") {
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        renderLabeledBuckets(value);
      } else {
        addText(value);
      }

      return;
    }
    if (key === "company_summary") {
      if (typeof value === "object" && !Array.isArray(value)) {
        Object.entries(value).forEach(([field, fieldValue]) => {
          const label = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());

          ensureSpace(18);

          doc.setFontSize(10);
          doc.setFont(undefined, "bold");
          doc.text(`${label}:`, margin, y);

          const formattedValue = sanitizeInlineText(
            typeof fieldValue === "object"
              ? JSON.stringify(fieldValue)
              : String(fieldValue ?? "-")
          );

          const lines = doc.splitTextToSize(
            formattedValue,
            maxWidth - 100
          );

          lines.forEach((line, index) => {
            if (index === 0) {
              doc.text(line, margin + 100, y);
              y += 14;
            } else {
              ensureSpace(14);
              doc.text(line, margin + 100, y);
              y += 14;
            }
          });
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "jd_summary" || key === "jd_breakdown") {
      if (typeof value === "object" && !Array.isArray(value)) {
        Object.entries(value).forEach(([field, fieldValue]) => {
          const label = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());

          ensureSpace(18);

          doc.setFontSize(10);
          doc.setFont(undefined, "bold");
          doc.text(sanitizeInlineText(label), margin, y);

          y += 14;

          if (Array.isArray(fieldValue)) {
            fieldValue.forEach((item) => {
              if (typeof item === "object" && item !== null) {
                const skillName = item.skill || item.name || item.title || "";

                if (skillName) {
                  ensureSpace(16);
                  doc.setFontSize(10);
                  doc.setFont(undefined, "bold");

                  const skillLines = doc.splitTextToSize(
                    sanitizeInlineText(skillName),
                    maxWidth - 10
                  );
                  skillLines.forEach((line) => {
                    ensureSpace(14);
                    doc.text(line, margin + 10, y);
                    y += 14;
                  });
                }

                Object.entries(item).forEach(([subField, subValue]) => {
                  if (
                    subField === "skill" ||
                    subField === "name" ||
                    subField === "title"
                  ) {
                    return;
                  }

                  if (
                    subValue === null ||
                    subValue === undefined ||
                    subValue === ""
                  ) {
                    return;
                  }

                  const subLabel = subField
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) => char.toUpperCase());

                  addText(
                    `${subLabel}: ${typeof subValue === "object"
                      ? JSON.stringify(subValue)
                      : subValue
                    }`,
                    { indent: 20 }
                  );
                });

                y += 4;
              } else {
                addBullet(item);
              }
            });
          } else {
            addText(
              typeof fieldValue === "object"
                ? JSON.stringify(fieldValue)
                : fieldValue,
              { indent: 8 }
            );
          }

          y += 5;
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "mandatory_skill_primer") {
      if (Array.isArray(value)) {
        value.forEach((skill, index) => {
          if (typeof skill === "object") {
            const title =
              skill.skill ||
              skill.name ||
              skill.title ||
              `Skill ${index + 1}`;

            doc.setFontSize(10);
            doc.setFont(undefined, "bold");
            ensureSpace(18);

            const titleLines = doc.splitTextToSize(
              sanitizeInlineText(title),
              maxWidth
            );
            titleLines.forEach((line) => {
              ensureSpace(14);
              doc.text(line, margin, y);
              y += 14;
            });

            Object.entries(skill).forEach(([field, fieldValue]) => {
              if (
                field === "skill" ||
                field === "name" ||
                field === "title"
              ) {
                return;
              }

              const label = field
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase());

              addText(
                `${label}: ${typeof fieldValue === "object"
                  ? JSON.stringify(fieldValue)
                  : fieldValue
                }`,
                { indent: 10 }
              );
            });

            y += 5;
          } else {
            addBullet(skill);
          }
        });
      } else if (typeof value === "object") {
        Object.entries(value).forEach(([field, fieldValue]) => {
          const label = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());

          addText(`${label}: ${fieldValue}`);
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "screening_questions") {
      if (Array.isArray(value)) {
        value.forEach((question, index) => {
          if (typeof question === "object" && question !== null) {
            const questionText =
              question.question ||
              question.text ||
              question.name ||
              JSON.stringify(question);

            addNumberedItem(index + 1, questionText);

            Object.entries(question).forEach(([field, fieldValue]) => {
              if (
                field === "question" ||
                field === "text" ||
                field === "name"
              ) {
                return;
              }

              if (
                fieldValue === null ||
                fieldValue === undefined ||
                fieldValue === ""
              ) {
                return;
              }

              const label = field
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase());

              addText(
                `${label}: ${typeof fieldValue === "object"
                  ? JSON.stringify(fieldValue)
                  : fieldValue
                }`,
                { indent: 20 }
              );
            });

            y += 5;
          } else {
            addNumberedItem(index + 1, question);
          }
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "target_companies") {
      if (Array.isArray(value)) {
        value.forEach((company) => {
          if (typeof company === "object") {
            const companyName =
              company.name ||
              company.company_name ||
              company.company ||
              JSON.stringify(company);

            addBullet(companyName);

            Object.entries(company).forEach(
              ([field, fieldValue]) => {
                if (
                  field === "name" ||
                  field === "company_name" ||
                  field === "company"
                ) {
                  return;
                }

                addText(
                  `${field
                    .replace(/_/g, " ")
                    .replace(/\b\w/g, (char) =>
                      char.toUpperCase()
                    )}: ${typeof fieldValue === "object"
                      ? JSON.stringify(fieldValue)
                      : fieldValue
                  }`,
                  { indent: 20 }
                );
              }
            );
          } else {
            addBullet(company);
          }
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "boolean_search_strings") {
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        const renderPlatformGroup = (platformLabel, platformValue) => {
          ensureSpace(20);
          doc.setFontSize(11);
          doc.setFont(undefined, "bold");
          doc.text(platformLabel, margin, y);
          y += 16;

          if (typeof platformValue === "object" && platformValue !== null) {
            Object.entries(platformValue).forEach(([variant, query]) => {
              const variantLabel = variant
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase());

              ensureSpace(16);
              doc.setFontSize(10);
              doc.setFont(undefined, "bold");
              doc.text(variantLabel, margin + 10, y);
              y += 14;

              addText(query, { indent: 10 });
              y += 6;
            });
          } else {
            addText(platformValue, { indent: 10 });
          }

          y += 6;
        };

        if (value.naukri) renderPlatformGroup("Naukri", value.naukri);
        if (value.linkedin) renderPlatformGroup("LinkedIn", value.linkedin);
        if (value.linkedin_xray)
          renderPlatformGroup("Google X-Ray (LinkedIn)", value.linkedin_xray);

        if (
          Array.isArray(value.additional_search_angles) &&
          value.additional_search_angles.length > 0
        ) {
          ensureSpace(20);
          doc.setFontSize(11);
          doc.setFont(undefined, "bold");
          doc.text("Additional Search Angles", margin, y);
          y += 16;

          value.additional_search_angles.forEach((entry) => {
            if (typeof entry === "object" && entry !== null) {
              const angle = entry.angle || entry.title || entry.name || "";
              const whenToUse = entry.when_to_use || entry.whenToUse || "";
              const searchString =
                entry.search_string || entry.searchString || entry.query || "";

              if (angle) {
                ensureSpace(16);
                doc.setFontSize(10);
                doc.setFont(undefined, "bold");

                const angleLines = doc.splitTextToSize(
                  sanitizeInlineText(angle),
                  maxWidth - 10
                );
                angleLines.forEach((line) => {
                  ensureSpace(14);
                  doc.text(line, margin + 10, y);
                  y += 14;
                });
              }

              if (whenToUse) {
                addText(`When to use: ${whenToUse}`, { indent: 20 });
              }

              if (searchString) {
                addText(searchString, { indent: 20 });
              }

              y += 6;
            } else {
              addBullet(entry);
            }
          });
        }

        const knownKeys = [
          "naukri",
          "linkedin",
          "linkedin_xray",
          "additional_search_angles",
        ];

        Object.entries(value).forEach(([field, fieldValue]) => {
          if (knownKeys.includes(field)) return;

          const label = field
            .replace(/_/g, " ")
            .replace(/\b\w/g, (char) => char.toUpperCase());

          ensureSpace(16);
          doc.setFontSize(10);
          doc.setFont(undefined, "bold");
          doc.text(label, margin, y);
          y += 14;

          addText(
            typeof fieldValue === "object"
              ? JSON.stringify(fieldValue)
              : fieldValue,
            { indent: 10 }
          );
          y += 5;
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "linkedin_search_keywords") {
      if (Array.isArray(value)) {
        value.forEach((keyword) => {
          if (typeof keyword === "object") {
            addBullet(
              keyword.keyword ||
              keyword.term ||
              keyword.name ||
              JSON.stringify(keyword)
            );
          } else {
            addBullet(keyword);
          }
        });
      } else if (typeof value === "object" && value !== null) {
        renderLabeledBuckets(value);
      } else {
        addText(value);
      }

      return;
    }

    if (key === "false_positives") {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          if (typeof item === "object") {
            const trap =
              item.trap ||
              item.title ||
              item.skill ||
              item.name ||
              "";

            const tell =
              item.tell ||
              item.reason ||
              item.description ||
              item.explanation ||
              "";

            const action =
              item.recruiter_action ||
              item.action ||
              "";

            if (trap) {
              doc.setFontSize(10);
              doc.setFont(undefined, "bold");

              const trapLines = doc.splitTextToSize(
                sanitizeInlineText(trap),
                maxWidth
              );

              trapLines.forEach((line) => {
                ensureSpace(14);
                doc.text(line, margin, y);
                y += 14;
              });
            }

            if (tell) {
              addText(`How to spot: ${tell}`, {
                indent: 10,
              });
            }

            if (action) {
              addText(`Recruiter action: ${action}`, {
                indent: 10,
              });
            }

            y += 5;
          } else {
            addBullet(item);
          }
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "skills_understanding") {
      if (Array.isArray(value)) {
        value.forEach((entry, index) => {
          if (typeof entry === "object" && entry !== null) {
            const title =
              entry.skill ||
              entry.name ||
              entry.title ||
              `Skill ${index + 1}`;

            doc.setFontSize(10);
            doc.setFont(undefined, "bold");
            ensureSpace(18);

            const titleLines = doc.splitTextToSize(
              sanitizeInlineText(title),
              maxWidth
            );
            titleLines.forEach((line) => {
              ensureSpace(14);
              doc.text(line, margin, y);
              y += 14;
            });

            Object.entries(entry).forEach(([field, fieldValue]) => {
              if (
                field === "skill" ||
                field === "name" ||
                field === "title"
              ) {
                return;
              }

              if (
                fieldValue === null ||
                fieldValue === undefined ||
                fieldValue === ""
              ) {
                return;
              }

              const label = field
                .replace(/_/g, " ")
                .replace(/\b\w/g, (char) => char.toUpperCase());

              addText(
                `${label}: ${typeof fieldValue === "object"
                  ? JSON.stringify(fieldValue)
                  : fieldValue
                }`,
                { indent: 10 }
              );
            });

            y += 5;
          } else {
            addBullet(entry);
          }
        });
      } else {
        addText(value);
      }

      return;
    }

    if (key === "ideal_candidate") {
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        renderLabeledBuckets(value);
      } else {
        addText(value);
      }

      return;
    }

    if (key === "recruiter_shortlisting_guide") {
      if (typeof value === "object" && value !== null && !Array.isArray(value)) {
        renderLabeledBuckets(value);
      } else {
        addText(value);
      }

      return;
    }

    if (Array.isArray(value)) {
      value.forEach((item, index) => {
        if (typeof item === "object") {
          Object.entries(item).forEach(([field, fieldValue]) => {
            const label = field
              .replace(/_/g, " ")
              .replace(/\b\w/g, (char) => char.toUpperCase());

            addText(
              `${label}: ${typeof fieldValue === "object"
                ? JSON.stringify(fieldValue)
                : fieldValue
              }`
            );
          });

          y += 5;
        } else {
          addNumberedItem(index + 1, item);
        }
      });
    } else if (typeof value === "object") {
      Object.entries(value).forEach(([field, fieldValue]) => {
        const label = field
          .replace(/_/g, " ")
          .replace(/\b\w/g, (char) => char.toUpperCase());

        addText(
          `${label}: ${typeof fieldValue === "object"
            ? JSON.stringify(fieldValue)
            : fieldValue
          }`
        );
      });
    } else {
      addText(value);
    }
  };

  doc.setFontSize(18);
  doc.setFont(undefined, "bold");
  doc.text("Sourcing Report", margin, y);

  y += 22;

  doc.setFontSize(11);
  doc.setFont(undefined, "normal");

  const displayCompanyName =
    (item.end_client && item.end_client.trim()) ||
    item.company_name ||
    "-";

  const companyRole = `${displayCompanyName} — ${item.role_title || "-"}`;

  addText(companyRole, {
    fontSize: 11,
    spacing: 16,
  });

  y += 12;

  if (isRawText) {
    ensureSpace(40);
    y += 8;
    renderRawTextReport(reportData);
  } else {
    SOURCING_REPORT_FIELDS.forEach((field) => {
      ensureSpace(40);

      y += 8;

      doc.setFontSize(13);
      doc.setFont(undefined, "bold");
      doc.text(field.label, margin, y);

      y += 8;

      doc.setDrawColor(79, 70, 229);
      doc.setLineWidth(1);
      doc.line(
        margin,
        y,
        margin + maxWidth,
        y
      );

      y += 18;

      renderReportValue(
        field.key,
        normalizedReport[field.key]
      );

      y += 12;
    });
  }

  const filename = `${displayCompanyName}_${item.role_title || "Role"}_Sourcing_Report`
    .replace(/\s+/g, "_");

  doc.save(`${filename}.pdf`);

  if (typeof onReportDownloaded === "function") {
    onReportDownloaded(item);
  }
};

/* ─────────────────────────────────────────────────────────────────────────── */

const ThemeTable = () => {
  const adminAccess = localStorage.getItem("adminAccess");
  const userName = localStorage.getItem("user_name");

  const [todayDemandsData, setTodayDemandsData] = useState([]);
  const [allDemandsData, setAllDemandsData] = useState([]);
  const [allTotal, setAllTotal] = useState(0);
  const [isTableLoading, setIsTableLoading] = useState(false);
  const [sortField, setSortField] = useState("created_at");

  const [todayCurrentPage, setTodayCurrentPage] = useState(1);
  const [todayItemsPerPage, setTodayItemsPerPage] = useState(10);

  const [allCurrentPage, setAllCurrentPage] = useState(1);
  const [allItemsPerPage, setAllItemsPerPage] = useState(10);

  const [companyList, setCompanyList] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedRole, setSelectedRole] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [recruiterOptions, setRecruiterOptions] = useState([]);
  const [selectedRecruiter, setSelectedRecruiter] = useState(null);
  const [recruiterId, setRecruiterId] = useState(null);
  const [selectedActiveStatus, setSelectedActiveStatus] = useState(null);
  const [selectedDemandCategory, setSelectedDemandCategory] = useState(null);
  const [togglingIds, setTogglingIds] = useState(new Set());

  const [sourcingReportCache, setSourcingReportCache] = useState({});
  const [generatingReportKey, setGeneratingReportKey] = useState(null);

  const reportKey = (item) => `${item.company_name}||${item.role_title}`;


  const getSourcingReportData = (item) => {
    let report = item?.intelligence_report || sourcingReportCache[reportKey(item)] || null;

    if (!report) return null;

    if (typeof report === "object" && !Array.isArray(report) && "report" in report) {
      report = report.report;
    }

    if (typeof report === "string") {
      const trimmed = report.trim();
      if (!trimmed) return null;

      try {
        report = JSON.parse(trimmed);
      } catch (e) {
        return trimmed;
      }
    }

    return report || null;
  };

  const handleReportDownloaded = async (item) => {
    console.log("========== REPORT DOWNLOADED ==========");
    console.log("FULL ITEM:", item);
    console.log("item.id:", item?.id);
    console.log("item.recruiter_id:", item?.recruiter_id);
    console.log(
      "item.demand_detail_recruiter_id:",
      item?.demand_detail_recruiter_id
    );
    console.log("adminAccess:", adminAccess);
    if (adminAccess !== "3") {
      console.log("Not recruiter/adminAccess 3 - skipping DB update");
      return;
    }

    if (!item?.demand_detail_recruiter_id) {
      console.error(
        "❌ demand_detail_recruiter_id is missing from item"
      );
      return;
    }
    console.log(
      "Sending demand_detail_recruiter_id:",
      item.demand_detail_recruiter_id
    );

    try {
      const response = await functionService.updateIntelligenceReportCheck({
        demand_detail_recruiter_id: item.demand_detail_recruiter_id,
      });

      if (response?.status) {
        const updateRow = (rows) =>
          rows.map((row) =>
            row.id === item.id &&
              row.demand_detail_recruiter_id ===
              item.demand_detail_recruiter_id
              ? {
                ...row,
                intelligence_report_check: true,
              }
              : row
          );

        setTodayDemandsData((prev) => updateRow(prev));
        setAllDemandsData((prev) => updateRow(prev));
      } else {
        console.error(
          "Failed to update intelligence_report_check:",
          response?.error
        );
      }
    } catch (error) {
      console.error(
        "Error updating intelligence_report_check:",
        error
      );
    }
  };

  const generateSourcingReport = async (item) => {
    const key = reportKey(item);

    const existingReport = item?.intelligence_report || sourcingReportCache[key];
    if (existingReport && adminAccess !== "0") {
      return;
    }

    setGeneratingReportKey(key);

    try {
      const response = await functionService.getSourcingReport({
        demand_id: item.id,
      });

      console.log("DEBUG generate response:", response);

      if (response?.status) {
        const data = response.response.data.data.report;
        console.log("DEBUG extracted data:", data);

        setSourcingReportCache((prev) => ({
          ...prev,
          [key]: data,
        }));

        const updateRow = (list) =>
          list.map((r) =>
            r.id === item.id ? { ...r, intelligence_report: data } : r
          );

        setTodayDemandsData((prev) => updateRow(prev));
        setAllDemandsData((prev) => updateRow(prev));
      } else {
        console.error("Error generating sourcing report:", response?.error);
        message.error(
          getSourcingReportErrorMessage(response?.error)
        );
      }
    } catch (error) {
      console.error("Error generating sourcing report:", error);
      message.error(getSourcingReportErrorMessage(error));
    } finally {
      setGeneratingReportKey(null);
    }
  };


  const [selectedSubAccount, setSelectedSubAccount] = useState(null);
  const [selectedEndClient, setSelectedEndClient] = useState(null);
  const [selectedSpoc, setSelectedSpoc] = useState(null);
  const [id, setId] = useState(null);
  const [selectedDate, setSelectedDate] = useState(null);
  const [sortOrder, setSortOrder] = useState("desc");
  const navigate = useNavigate();

  const [filterListData, setFilterListData] = useState([]);

  const getDemandFilterList = async () => {
    try {
      const response = await functionService.get("demand/demand-filter-list");
      const data = response?.response?.data?.data;

      if (Array.isArray(data)) {
        setFilterListData(data);
      } else {
        console.error("Unexpected demand/demand-filter-list response:", response);
        setFilterListData([]);
      }
    } catch (error) {
      console.error("Error fetching demand/demand-filter-list:", error);
      setFilterListData([]);
    }
  };

  const getCompanyName = async () => {
    try {
      const userId = localStorage.getItem("userId");

      console.log("Recruiter userId:", userId);

      if (!userId) {
        console.error("No recruiter userId found");
        setCompanyList([]);
        return;
      }

      const response = await functionService.get(
        `demand/all-personalized-companies-list/${userId}`
      );

      const companies = response?.response?.data?.data;

      if (Array.isArray(companies)) {
        console.log("SETTING COMPANY LIST:", companies);
        console.log("COMPANY COUNT:", companies.length);

        setCompanyList(companies);
      } else {
        console.error("Companies is not an array:", companies);

        setCompanyList([]);
      }

    } catch (error) {
      console.error("Error fetching company names:", error);

      setCompanyList([]);
    }
  };

  const recruiterSearch = async () => {
    let res = await functionService.get(`demand/recruiters-list`);
    let apiData = res?.response?.data?.data;
    const optionsWithNames = apiData.map((item) => ({
      ...item,
      recruiter_name: item.label,
    }));
    setRecruiterOptions(optionsWithNames);
  };

  const buildDemandQueryParams = (section, page, limit) => {
    const params = { section };

    if (page !== undefined) params.page = page;
    if (limit !== undefined) params.limit = limit;

    if (selectedCompany) params.company_name = selectedCompany;
    if (selectedSubAccount) params.sub_account = selectedSubAccount;
    if (selectedEndClient) params.end_client = selectedEndClient;
    if (selectedSpoc) params.spoc_name = selectedSpoc;
    if (selectedRole) params.role_title = selectedRole;
    if (selectedRecruiter) params.recruiter_name = selectedRecruiter;
    if (selectedStatus) params.status = selectedStatus;
    if (selectedActiveStatus !== null && selectedActiveStatus !== undefined) {
      params.active = selectedActiveStatus === "active";
    }
    if (selectedDemandCategory) params.demand_category = selectedDemandCategory;
    if (selectedDate) params.updated_date = selectedDate.format("YYYY-MM-DD");

    if (section === "all") {
      params.sort = sortField;
      params.order = sortOrder;
    }

    return params;
  };

  const fetchAllDemands = async () => {
    setIsTableLoading(true);
    try {
      const params = buildDemandQueryParams("all", allCurrentPage, allItemsPerPage);
      const demandDetails = await functionService.getDemandDetails(params);

      if (demandDetails.status) {
        const payload = demandDetails.response.data.data;
        const records = Array.isArray(payload) ? payload : (payload?.data || []);
        const total = Array.isArray(payload) ? records.length : (payload?.total ?? records.length);

        setAllDemandsData(records);
        setAllTotal(total);
      } else {
        console.error("Error fetching all demand details:", demandDetails.error);
      }
    } catch (error) {
      console.error("Error in fetchAllDemands:", error);
    } finally {
      setIsTableLoading(false);
    }
  };

  const fetchTodayDemands = async () => {
    try {
      const params = buildDemandQueryParams("today");
      const demandDetails = await functionService.getDemandDetails(params);

      if (demandDetails.status) {
        const payload = demandDetails.response.data.data;
        const records = Array.isArray(payload) ? payload : (payload?.data || []);

        setTodayDemandsData(records);
      } else {
        console.error("Error fetching today's demand details:", demandDetails.error);
      }
    } catch (error) {
      console.error("Error in fetchTodayDemands:", error);
    }
  };

  useEffect(() => {
    getCompanyName();
    recruiterSearch();
    getDemandFilterList();
  }, []);

  useEffect(() => {
    const deleteFromDemandDetails = async () => {
      try {
        let res = await functionService.deleteFromDemandDetails({ id: id, recruiter_id: recruiterId });
        if (res.status) {
          fetchAllDemands();
          fetchTodayDemands();
        } else {
          console.error("Error deleting demand details:", res.error);
        }
      } catch (error) {
        console.error("Error in deleteFromDemandDetails:", error);
      }
    };

    if (id && recruiterId) {
      deleteFromDemandDetails();
    }
  }, [id, recruiterId]);

  useEffect(() => {
    fetchAllDemands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    allCurrentPage,
    allItemsPerPage,
    sortField,
    sortOrder,
    selectedCompany,
    selectedSubAccount,
    selectedEndClient,
    selectedSpoc,
    selectedRole,
    selectedRecruiter,
    selectedActiveStatus,
    selectedDemandCategory,
    selectedStatus,
    selectedDate,
    id,
  ]);

  useEffect(() => {
    fetchTodayDemands();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    selectedCompany,
    selectedSubAccount,
    selectedEndClient,
    selectedSpoc,
    selectedRole,
    selectedRecruiter,
    selectedActiveStatus,
    selectedDemandCategory,
    selectedStatus,
    selectedDate,
    id,
  ]);

  // ── Cascading filter options (Role, Sub-account, End Client, SPOC) ─────────
  // Company keeps its existing companyList source and is NOT derived from
  // filterListData — but selectedCompany still narrows these other four.
  // Each of these four excludes only itself from the filter chain, so any
  // of them can be selected first, in any order.
  const getFilteredFilterData = (excludeKey) => {
    return filterListData.filter((item) => {
      if (selectedCompany && item.company_name !== selectedCompany) return false;
      if (excludeKey !== "role" && selectedRole && item.role_title !== selectedRole) return false;
      if (excludeKey !== "subAccount" && selectedSubAccount && item.sub_account !== selectedSubAccount) return false;
      if (excludeKey !== "endClient" && selectedEndClient && item.end_client !== selectedEndClient) return false;
      if (excludeKey !== "spoc" && selectedSpoc && item.spoc_name !== selectedSpoc) return false;
      return true;
    });
  };

    // Company also participates in the cascade: starts from the existing
  // companyList (preserving whatever access/personalization restrictions
  // it already encodes), then keeps only the companies that have at least
  // one matching row in filterListData under the currently selected
  // Role/Sub-account/End Client/SPOC. selectedCompany is intentionally
  // excluded — a dropdown must not filter itself. companyList holds
  // objects ({ company_name, ... }), not plain strings, so extraction
  // uses item.company_name to match the existing Select's own pattern.
  const companyOptionsComputed = useMemo(() => {
    const filteredData = filterListData.filter((item) => {
      if (selectedRole && item.role_title !== selectedRole) return false;
      if (selectedSubAccount && item.sub_account !== selectedSubAccount) return false;
      if (selectedEndClient && item.end_client !== selectedEndClient) return false;
      if (selectedSpoc && item.spoc_name !== selectedSpoc) return false;
      return true;
    });

    const matchingCompanies = new Set(
      filteredData.map((item) => item.company_name).filter(Boolean)
    );

    return [
      ...new Map(
        (companyList || [])
          .filter(
            (item) =>
              item &&
              item.company_name &&
              String(item.company_name).trim() !== "" &&
              matchingCompanies.has(item.company_name)
          )
          .map((item) => [
            String(item.company_name).trim().toLowerCase(),
            {
              label: String(item.company_name).trim(),
              value: String(item.company_name).trim(),
            },
          ])
      ).values(),
    ].sort((a, b) => a.label.localeCompare(b.label));
  }, [
    companyList,
    filterListData,
    selectedRole,
    selectedSubAccount,
    selectedEndClient,
    selectedSpoc,
  ]);

  const roleOptionsComputed = useMemo(
    () => [...new Set(getFilteredFilterData("role").map((i) => i.role_title).filter(Boolean))].sort(),
    [filterListData, selectedCompany, selectedSubAccount, selectedEndClient, selectedSpoc]
  );

  const subAccountOptionsComputed = useMemo(
    () => [...new Set(getFilteredFilterData("subAccount").map((i) => i.sub_account).filter(Boolean))].sort(),
    [filterListData, selectedCompany, selectedRole, selectedEndClient, selectedSpoc]
  );

  const endClientOptionsComputed = useMemo(
    () => [...new Set(getFilteredFilterData("endClient").map((i) => i.end_client).filter(Boolean))].sort(),
    [filterListData, selectedCompany, selectedRole, selectedSubAccount, selectedSpoc]
  );

  const spocOptionsComputed = useMemo(
    () => [...new Set(getFilteredFilterData("spoc").map((i) => i.spoc_name).filter(Boolean))].sort(),
    [filterListData, selectedCompany, selectedRole, selectedSubAccount, selectedEndClient]
  );

  // Reset sub-account and end-client selections only when company changes
  // (existing behavior, preserved exactly)
  useEffect(() => {
    setSelectedSubAccount(null);
    setSelectedEndClient(null);
    setSelectedSpoc(null);
  }, [selectedCompany]);

  const formatDate = (dateString) => {
    if (!dateString) return "-";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-GB", { day: "2-digit", month: "short", year: "numeric" });
    } catch (error) {
      return "Invalid date";
    }
  };

  const downloadJD = (url, item) => {
    const filename = `JD_${item.company_name}_${item.role_title}`.replace(/\s+/g, "_");
    DownloadAssets(url, filename);
  };

  const downloadMiscellaneousFile = (url, item) => {
    const filename =
      `Misc_File_${item.company_name}_${item.role_title}`
        .replace(/\s+/g, "_");

    DownloadAssets(url, filename);
  };

  const sortByCreatedDate = () => {
    setSortField("created_at");
    setSortOrder((prev) => (prev === "asc" ? "desc" : "asc"));
  };

  const formatLocation = (location) => {
    if (!location) return "-";
    if (typeof location === "string" && location.includes(",")) return location;
    if (typeof location === "string") return location.split(/\s+/).filter(Boolean).join(", ");
    if (Array.isArray(location)) return location.join(", ");
    return "-";
  };

  const buildCsvRows = (records) => {
    const csvRows = [];
    const headers = [
      "Account Name", "Role", "Sub Accournt", "End Client", "Job Code", "Experience", "Salary", "Job Type",
      "Location Type", "Location", "Time Zone", "Openings", "Assigned Recruiter",
      "Created On", "Updated On", "Received On", "Active/Inactive", "Remarks", "JD Link", "Assessment Link"
    ];
    csvRows.push(headers.join(","));

    records.forEach((item) => {
      const activeStatus = item.active ? "Active" : "Inactive";
      const row = [
        `"${item.company_name || ""}"`,
        `"${item.role_title || ""}"`,
        `"${item.sub_account || ""}"`,
        `"${item.end_client || ""}"`,
        `"${item.job_code || ""}"`,
        `"${Number(item.min_yrs).toFixed(1)} - ${Number(item.max_yrs).toFixed(1)} years"`,
        `"${parseInt(item.min_ctc)} - ${parseInt(item.max_ctc)} LPA"`,
        `"${item.job_type || ""}"`,
        `"${item.recruiter_location_type || ""}"`,
        `"${item.recruiter_location ? item.recruiter_location === "REMOTE" ? "-" : item.recruiter_location.replace(/[{}"]/g, "").split(",").join(", ") : "-"}"`,
        `"${item.timezone || ""}"`,
        `"${item.openings ? item.openings : "-"}"`,
        `"${item.recruiter_name || ""}"`,
        `"${formatDate(item.created_at) || "Not available"}"`,
        `"${formatDate(item.updated_at) || "Not available"}"`,
        `"${formatDate(item.received_date) || "-"}"`,
        `"${activeStatus}"`,
        `"${item.remarks || ""}"`,
        `"${item.job_desc || ""}"`,
        `"${item.assessment_link || ""}"`,
      ];
      csvRows.push(row.join(","));
    });

    return csvRows.join("\n");
  };

  const triggerCsvDownload = (csvString) => {
    const blob = new Blob([csvString], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.setAttribute("href", url);
    a.setAttribute("download", "demand_table.csv");
    a.click();
    URL.revokeObjectURL(url);
  };

  const exportToCSV = async () => {
    setIsTableLoading(true);
    try {
      const params = buildDemandQueryParams("all");
      params.export = true;
      const demandDetails = await functionService.getDemandDetails(params);

      if (!demandDetails.status) {
        message.error("Failed to export CSV. Please try again.");
        console.error("Error exporting demand details:", demandDetails.error);
        return;
      }

      const payload = demandDetails.response.data.data;
      const records = Array.isArray(payload) ? payload : (payload?.data || []);

      triggerCsvDownload(buildCsvRows(records));
    } catch (error) {
      console.error("Error in exportToCSV:", error);
      message.error("Failed to export CSV. Please try again.");
    } finally {
      setIsTableLoading(false);
    }
  };

  const copyToClipboard = async (text) => {
    try {
      if (navigator.clipboard && navigator.clipboard.writeText) {
        await navigator.clipboard.writeText(text);
        return true;
      }
      const textArea = document.createElement("textarea");
      textArea.value = text;
      textArea.style.position = "fixed";
      textArea.style.left = "-999999px";
      textArea.style.top = "-999999px";
      document.body.appendChild(textArea);
      textArea.focus();
      textArea.select();
      const successful = document.execCommand("copy");
      document.body.removeChild(textArea);
      return successful;
    } catch (err) {
      console.error("Failed to copy text: ", err);
      return false;
    }
  };

  const truncateText = (text, maxLength = 30) => {
    if (!text || text === "") return "-";
    if (text.length <= maxLength) return text;
    return text.substring(0, maxLength) + "...";
  };

  const handleActiveToggle = async (item) => {
    const rowKey = `${item.id}_${item.recruiter_id}`;

    const flipActive = (list) =>
      list.map((r) =>
        r.id === item.id && r.recruiter_id === item.recruiter_id
          ? { ...r, active: !r.active }
          : r
      );

    setTodayDemandsData((prev) => flipActive(prev));
    setAllDemandsData((prev) => flipActive(prev));
    setTogglingIds((prev) => new Set(prev).add(rowKey));

    try {
      const res = await functionService.deleteFromDemandDetails({
        id: item.id,
        recruiter_id: item.recruiter_id,
      });

      if (res.status) {
        message.success(`Demand marked as ${!item.active ? "active" : "inactive"}`);
        fetchAllDemands();
        fetchTodayDemands();
      } else {
        setTodayDemandsData((prev) => flipActive(prev));
        setAllDemandsData((prev) => flipActive(prev));
        message.error("Failed to update status. Please try again.");
      }
    } catch (error) {
      setTodayDemandsData((prev) => flipActive(prev));
      setAllDemandsData((prev) => flipActive(prev));
      message.error("Something went wrong.");
    } finally {
      setTogglingIds((prev) => {
        const next = new Set(prev);
        next.delete(rowKey);
        return next;
      });
    }
  };

  const todayListings = todayDemandsData;
  const allDemandsListings = allDemandsData;

  const totalTodayPages = 1;
  const todayItemsToDisplay = todayListings;

  const totalAllPages = Math.max(1, Math.ceil(allTotal / allItemsPerPage));
  const allItemsToDisplay = allDemandsListings;

  const buildPageNumbers = (currentPage, totalPages) => {
    const pages = [];
    if (totalPages <= 7) {
      for (let i = 1; i <= totalPages; i++) pages.push(i);
      return pages;
    }
    pages.push(1);
    if (currentPage > 3) pages.push("...");
    for (let i = Math.max(2, currentPage - 1); i <= Math.min(totalPages - 1, currentPage + 1); i++) {
      pages.push(i);
    }
    if (currentPage < totalPages - 2) pages.push("...");
    pages.push(totalPages);
    return pages;
  };

  const renderTableRows = (items) =>
    items.map((item, index) => {

      const rowKey = `${item.id}_${item.recruiter_id}`;
      const isToggling = togglingIds.has(rowKey);

      const sourcingReportData = getSourcingReportData(item);

      const sourcingReportAction = (
        <>
          {sourcingReportData && (
            <DownloadReportButton
              onClick={() =>
                downloadSourcingReportPDF(
                  item,
                  sourcingReportData,
                  adminAccess === "3" ? handleReportDownloaded : null
                )
              }
            />
          )}

          {(adminAccess === "0" ||
            (!sourcingReportData && adminAccess !== "3")) && (
              <GenerateSourcingReportButton
                item={item}
                isGenerating={generatingReportKey === reportKey(item)}
                onGenerate={generateSourcingReport}
              />
            )}
        </>
      );

      return (
        <tr key={index}>
          <td
            style={{
              position: "relative",
              paddingTop: "14px",
            }}
          >
            {item.demand_category === "High Probability Closure" && (
              <span
                style={{
                  position: "absolute",
                  top: "2px",
                  left: "6px",
                  color: "red",
                  fontSize: "12px",
                  fontWeight: "bold",
                  zIndex: 10,
                }}
              >
                *Priority*
              </span>
            )}

            {formatDate(item.created_at) || "Not available"}
          </td>
          <td>{formatDate(item.updated_at) || "Not available"}</td>
          <td>{formatDate(item.received_date) || "-"}</td>
          <td style={{ position: "sticky", top: 0, left: 0, zIndex: 11, background: "#FFFFFF", minWidth: "150px" }}>{item.recruiter_name}</td>
          <td style={{ position: "sticky", top: 0, left: "50px", zIndex: 11, background: "#FFFFFF", minWidth: "150px" }}>{item.company_name}</td>
          <td style={{ position: "sticky", top: 0, left: "150px", zIndex: 11, background: "#FFFFFF", minWidth: "150px" }}>{item.role_title}</td>
          <td>{item.job_code || "-"}</td>
          <td>{item.demand_category || "-"}</td>
          <td>{item.recruiter_job_type.toUpperCase() || item.job_type.toUpperCase()}</td>
          <td>
            {item.max_yrs
              ? `${parseFloat(item.min_yrs)} - ${parseFloat(item.max_yrs)} years`
              : `${parseFloat(item.min_yrs)}+ years`}
          </td>
          <td>{
            item.recruiter_min_ctc && item.recruiter_max_ctc
              ? `${parseInt(item.recruiter_min_ctc)} - ${parseInt(item.recruiter_max_ctc)} LPA`
              : item.recruiter_min_ctc
                ? `${parseInt(item.recruiter_min_ctc)}+ LPA`
                : item.recruiter_max_ctc
                  ? `Up to ${parseInt(item.recruiter_max_ctc)} LPA`
                  : "Not specified"
          }</td>
          <td>{
            item.recruiter_location_type === "HYBRID" && item.office_days
              ? `HYBRID - ${item.office_days} days`
              : item.recruiter_location_type || "-"
          }</td>
          <td>
            {item.recruiter_location
              ? item.recruiter_location === "REMOTE"
                ? "-"
                : item.recruiter_location.replace(/[{}"]/g, "").split(",").join(", ")
              : "-"}
          </td>
          <td>{item.timezone || "-"}</td>
          <td>{item.openings ? item.openings : "-"}</td>
          <td>{item.notice_period ? item.notice_period : "-"}</td>
          <td>
            <Tooltip title={item.company_process || "-"} placement="topLeft">
              <span style={{
                maxWidth: "150px",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer"
              }}>
                {truncateText(item.company_process, 25)}
              </span>
            </Tooltip>
          </td>
          <td>
            <Tooltip title={item.remarks || "-"} placement="topLeft">
              <span style={{
                maxWidth: "150px",
                display: "inline-block",
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                cursor: "pointer"
              }}>
                {truncateText(item.remarks, 25)}
              </span>
            </Tooltip>
          </td>

          {adminAccess > "2" ? (
            <td>
              <Styled.IconDiv>
                {sourcingReportAction}
                <EyeButton onClick={() => downloadJD(item.job_desc, item)} />
                {item.miscellaneous_file && (
                  <MiscFileButton
                    onClick={() =>
                      downloadMiscellaneousFile(
                        item.miscellaneous_file,
                        item
                      )
                    }
                  />
                )}
                <Tooltip
                  title={
                    item.assessment_link || item.assessmentLink
                      ? "Copy Assessment Link"
                      : "No Assessment Link"
                  }
                >
                  <button
                    onClick={async () => {
                      const link = item.assessment_link || item.assessmentLink;
                      if (link) {
                        const success = await copyToClipboard(link);
                        if (success) {
                          message.success("Assessment link copied successfully");
                        } else {
                          message.error("Failed to copy link. Please try again.");
                        }
                      } else {
                        message.info("No assessment available for this demand");
                      }
                    }}
                    style={{
                      opacity: item.assessment_link || item.assessmentLink ? 1 : 0.4,
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      border: "none",
                      background: "#DEE2EF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={copylink}
                      alt="assessment link"
                      style={{ width: "22px", height: "22px", objectFit: "contain" }}
                    />
                  </button>
                </Tooltip>
                <InviteButton
                  disabled={item.intelligence_report_check !== true}
                  onClick={() => {
                    if (
                      item.intelligence_report_check !== true
                    ) {
                      return;
                    }

                    navigate("/submission-form", {
                      state: {
                        company_name: item.company_name,
                        role_title: item.role_title,
                        locked: true,
                        demand_id: item.id,
                        recruiter_id: item.recruiter_id,
                      },
                    });
                  }}
                />
              </Styled.IconDiv>
            </td>
          ) : (
            <td>
              <Styled.IconDiv>
                {sourcingReportAction}
                <Tooltip title="Edit">
                  <button
                    onClick={() => {
                      localStorage.setItem("demand_table_id", item.id);
                      localStorage.setItem("demand_recruiter_id", item.recruiter_id);
                      navigate("/demand-form");
                    }}
                  >
                    <img src={editIcon} alt="edit" />
                  </button>
                </Tooltip>
                <EyeButton onClick={() => downloadJD(item.job_desc, item)} />
                {item.miscellaneous_file && (
                  <MiscFileButton
                    onClick={() =>
                      downloadMiscellaneousFile(
                        item.miscellaneous_file,
                        item
                      )
                    }
                  />
                )}
                <Tooltip
                  title={
                    item.assessment_link || item.assessmentLink
                      ? "Copy Assessment Link"
                      : "No Assessment Link"
                  }
                >
                  <button
                    onClick={async () => {
                      const link = item.assessment_link || item.assessmentLink;
                      if (link) {
                        const success = await copyToClipboard(link);
                        if (success) {
                          message.success("Assessment link copied successfully");
                        } else {
                          message.error("Failed to copy link. Please try again.");
                        }
                      } else {
                        message.info("No assessment link available for this demand");
                      }
                    }}
                    style={{
                      opacity: item.assessment_link || item.assessmentLink ? 1 : 0.4,
                      width: "32px",
                      height: "32px",
                      borderRadius: "8px",
                      border: "none",
                      background: "#DEE2EF",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <img
                      src={copylink}
                      alt="assessment link"
                      style={{ width: "32px", height: "22px", objectFit: "contain" }}
                    />
                  </button>
                </Tooltip>
                <Tooltip title={item.active ? "Mark as Inactive" : "Mark as Active"}>
                  <div>
                    <ActiveSwitch
                      active={!!item.active}
                      loading={isToggling}
                      onToggle={() => handleActiveToggle(item)}
                    />
                  </div>
                </Tooltip>
              </Styled.IconDiv>
            </td>
          )}
        </tr>
      );
    });

  const renderPagination = (currentPage, setCurrentPage, totalPages, itemsPerPage, setItemsPerPage, totalCount) => (
    <div style={paginationStyles.container}>
      <div style={paginationStyles.leftSection}>
        <span>Show</span>
        <Styled.PaginationSelectWrapper>
          <Select
            defaultValue={10}
            size="small"
            dropdownMatchSelectWidth={false}
            onChange={(value) => {
              setItemsPerPage(value);
              setCurrentPage(1);
            }}
          >
            <Select.Option value={10}>10</Select.Option>
            <Select.Option value={20}>20</Select.Option>
            <Select.Option value={50}>50</Select.Option>
          </Select>
        </Styled.PaginationSelectWrapper>
        <span>per page</span>
        <span style={{ marginLeft: "12px", color: "#9CA3AF" }}>|</span>
        <span style={{ marginLeft: "12px" }}>
          {(currentPage - 1) * itemsPerPage + 1}–
          {Math.min(currentPage * itemsPerPage, totalCount)} of {totalCount} results
        </span>
      </div>

      <div style={paginationStyles.pageControls}>
        <button
          style={paginationStyles.navBtn(currentPage === 1)}
          onClick={() => setCurrentPage((p) => p - 1)}
          disabled={currentPage === 1}
        >
          ← Prev
        </button>

        {buildPageNumbers(currentPage, totalPages).map((page, idx) =>
          page === "..." ? (
            <span key={`ellipsis-${idx}`} style={paginationStyles.ellipsis}>…</span>
          ) : (
            <button
              key={page}
              style={paginationStyles.pageBtn(page === currentPage, false)}
              onClick={() => setCurrentPage(page)}
            >
              {page}
            </button>
          )
        )}

        <button
          style={paginationStyles.navBtn(currentPage === totalPages)}
          onClick={() => setCurrentPage((p) => p + 1)}
          disabled={currentPage === totalPages}
        >
          Next →
        </button>
      </div>
    </div>
  );

  const EmptyState = () => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        height: "100%",
        marginTop: "60px",
        marginBottom: "40px",
      }}
    >
      <img
        src={require("../../images/Frame.png")}
        alt="No Data"
        style={{ width: "35%", height: "auto" }}
      />
      <h2 style={{ marginTop: "auto" }}>No Demand Allocated</h2>
    </div>
  );

  const renderTableSection = (
    label,
    listings,
    itemsToDisplay,
    currentPage,
    setCurrentPage,
    totalPages,
    itemsPerPage,
    setItemsPerPage,
    showPagination = true,
    totalCount = listings.length
  ) => (
    <div style={{ marginBottom: "32px" }}>
      <div style={sectionHeadingStyle}>{label}</div>

      <Styled.TableWrap style={{ overflowX: "auto", overflowY: "auto", maxHeight: "calc(100vh - 350px)" }}>
        {listings.length === 0 ? (
          <EmptyState />
        ) : (
          <Styled.MainTable style={{ width: "100%", whiteSpace: "nowrap" }}>
            <thead style={{ position: "sticky", top: 0, zIndex: 20, background: "#F2F6F8" }}>
              <tr>
                <th onClick={sortByCreatedDate} style={{ cursor: "pointer" }}>
                  Created On
                </th>
                <th>Updated On</th>
                <th>Received On</th>
                <th style={{ position: "sticky", top: 0, left: 0, zIndex: 21, background: "#F2F6F8", minWidth: "150px" }}>Assigned Recruiter</th>
                <th style={{ position: "sticky", top: 0, left: "50px", zIndex: 21, background: "#F2F6F8", minWidth: "150px" }}>Account Name</th>
                <th style={{ position: "sticky", top: 0, left: "150px", zIndex: 21, background: "#F2F6F8", minWidth: "150px" }}>Role</th>
                <th>Job Code</th>
                <th>Demand Category</th>
                <th>Job Type</th>
                <th>Experience</th>
                <th>Budget</th>
                <th>Location Type</th>
                <th>Location</th>
                <th>Timezone</th>
                <th>Openings</th>
                <th>Notice Period</th>
                <th>Hiring Process</th>
                <th>Remarks</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>{renderTableRows(itemsToDisplay)}</tbody>
          </Styled.MainTable>
        )}
      </Styled.TableWrap>

      {showPagination && totalCount > 0 &&
        renderPagination(
          currentPage,
          setCurrentPage,
          totalPages,
          itemsPerPage,
          setItemsPerPage,
          totalCount
        )}
    </div>
  );

  const MIN_DATE = dayjs("2026-04-22").startOf("day");
  const disableFutureDates = (current) =>
    current && (current > dayjs().endOf("day") || current < MIN_DATE);

  return (
    <Styled.MainDiv>
      <Sidemenu />

      <Styled.ContentWrapDiv>
        <Styled.TopContainer>
          <div className="leftSide">Demand's Table</div>
          {adminAccess <= "2" && (
            <div className="rightSide" style={{ display: "flex", gap: "10px" }}>
              <button onClick={exportToCSV}>Export</button>
              <button onClick={() => navigate("/demand-form")}>New Demand</button>
            </div>
          )}
        </Styled.TopContainer>

        <Styled.FilterContainer>
          <Select
            showSearch
            allowClear
            placeholder="Select a company"
            style={{ width: "200px", flexShrink: 0 }}
            onChange={(value) => {
              console.log("Selected company:", value);
              setSelectedCompany(value);
              setAllCurrentPage(1);
            }}
            options={companyOptionsComputed}
            filterOption={(input, option) => {
              const searchText = String(input || "")
                .trim()
                .toLowerCase();

              const label = String(option?.label || "").toLowerCase();

              return label.includes(searchText);
            }}
          />

          {console.log("COMPANY LIST:", companyList)}
          {console.log("COMPANY LIST LENGTH:", companyList?.length)}


          <Select
            showSearch
            placeholder="Select a role"
            optionFilterProp="children"
            onChange={(value) => {
              setSelectedRole(value);
              setAllCurrentPage(1);
            }}
            allowClear
            style={{ width: "200px", flexShrink: 0 }}
          >
            {roleOptionsComputed.map((role) => (
              <Select.Option key={role} value={role}>{role}</Select.Option>
            ))}
          </Select>

          <Select
            showSearch
            placeholder="Sub-account"
            onChange={(value) => {
              setSelectedSubAccount(value);
              setAllCurrentPage(1);
            }}
            allowClear
            style={{ width: "200px", flexShrink: 0 }}
            value={selectedSubAccount || undefined}
          >
            {subAccountOptionsComputed.map((s) => (
              <Select.Option key={s} value={s}>{s}</Select.Option>
            ))}
          </Select>

          <Select
            showSearch
            placeholder="End client"
            onChange={(value) => {
              setSelectedEndClient(value);
              setAllCurrentPage(1);
            }}
            allowClear
            style={{ width: "200px", flexShrink: 0 }}
            value={selectedEndClient || undefined}
          >
            {endClientOptionsComputed.map((e) => (
              <Select.Option key={e} value={e}>{e}</Select.Option>
            ))}
          </Select>
          <Select
            showSearch
            placeholder="SPOC"
            onChange={(value) => {
              setSelectedSpoc(value);
              setAllCurrentPage(1);
            }}
            allowClear
            style={{ width: "200px", flexShrink: 0 }}
            value={selectedSpoc || undefined}
          >
            {spocOptionsComputed.map((s) => (
              <Select.Option key={s} value={s}>{s}</Select.Option>
            ))}
          </Select>
          {adminAccess <= "2" && (

            <Select
              showSearch
              placeholder="Assigned recruiter"
              optionFilterProp="children"
              onChange={(value) => {
                setSelectedRecruiter(value);
                setAllCurrentPage(1);
              }}
              value={selectedRecruiter || undefined}
              allowClear
              style={{ width: "200px", flexShrink: 0 }}
              className="no-clear-option"
            >
              {recruiterOptions.length > 0 ? (
                recruiterOptions.map((item) => (
                  <Select.Option key={item.recruiter_name} value={item.recruiter_name}>
                    {item.recruiter_name}
                  </Select.Option>
                ))
              ) : (
                <Select.Option value="" disabled>
                  No recruiters available
                </Select.Option>
              )}
            </Select>
          )}

          <Select
            showSearch
            placeholder="Demand Category"
            optionFilterProp="children"
            onChange={(value) => {
              setSelectedDemandCategory(value);
              setAllCurrentPage(1);
            }}
            allowClear
            style={{ width: "220px", flexShrink: 0 }}
          >
            {[...new Set(filterListData.map((item) => item.demand_category).filter(Boolean))].map((category, index) => (
              <Select.Option key={index} value={category}>
                {category}
              </Select.Option>
            ))}
          </Select>

          <Select
            showSearch
            placeholder="Demand Status"
            optionFilterProp="children"
            onChange={(value) => {
              setSelectedActiveStatus(value);
              setAllCurrentPage(1);
            }}
            allowClear
            style={{ width: "180px", flexShrink: 0 }}
          >
            <Select.Option value="active">Active</Select.Option>
            <Select.Option value="inactive">Inactive</Select.Option>
          </Select>

          <DatePicker
            placeholder="Updated date"
            onChange={(date) => {
              setSelectedDate(date || null);
              setAllCurrentPage(1);
            }}
            format="DD MMM YYYY"
            allowClear
            disabledDate={disableFutureDates}
            style={{ width: "180px", flexShrink: 0 }}
          />
        </Styled.FilterContainer>

        {adminAccess > "2"
          ? renderTableSection(
            "Today's Demands",
            todayListings,
            todayItemsToDisplay,
            todayCurrentPage,
            setTodayCurrentPage,
            totalTodayPages,
            todayItemsPerPage,
            setTodayItemsPerPage,
            false
          )
          : todayListings.length > 0 &&
          renderTableSection(
            "Today's Demands",
            todayListings,
            todayItemsToDisplay,
            todayCurrentPage,
            setTodayCurrentPage,
            totalTodayPages,
            todayItemsPerPage,
            setTodayItemsPerPage,
            false
          )}

        {renderTableSection(
          "All Demands",
          allDemandsListings,
          allItemsToDisplay,
          allCurrentPage,
          setAllCurrentPage,
          totalAllPages,
          allItemsPerPage,
          setAllItemsPerPage,
          true,
          allTotal
        )}
      </Styled.ContentWrapDiv>
    </Styled.MainDiv>
  );
};

export default ThemeTable;